import Routing from "./container/routes";

const App = () => {

 return(
        <>
          <Routing  />
        </>
    )
}

export default App;
//
// import React from 'react';
//
// const App = () => {
//     // Detect browser language
//     const browserLang = navigator.language || navigator.userLanguage;
//
//     // Check if browser language is Armenian
//     const message = "Խնդրում ենք թարմացնել էջը";
//
//     return (
//         <div style={{
//             minHeight: '100vh',
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//             backgroundColor: 'black',
//             fontFamily: 'Arial, sans-serif',
//             padding: '20px'
//         }}>
//             <h1 style={{
//                 color: 'white',
//                 fontSize: '24px',
//                 fontWeight: '400',
//                 textAlign: 'center',
//                 margin: 0,
//                 opacity: 0.9
//             }}>
//                 {message}
//             </h1>
//         </div>
//     );
// }
//
// export default App;